import teamleaderAPI from '@libs/focus-frontend-api/src/Teamleader';

export function dispatch(commandName: unknown, payload: unknown) {
  return new Promise((resolve, reject) => {
    return window.top!.services.authentication.getAccessToken().then((accessToken) => {
      return teamleaderAPI
        .dispatch({ commandName, payload, accessToken })
        .then(resolve)
        .catch((error) => {
          if (error && error.response) {
            reject(error.response);
          } else {
            reject(new Error('Something went wrong while dispatching your command'));
          }
        });
    });
  });
}
